import { getURLParameter } from './utilities.js';
import 'jquery-ui/ui/widgets/slider';
import 'jquery-ui/themes/base/slider.css';
import '../../themes/categories.css'
import './jquery.ui.touch-punch.min.js';

jQuery(function () {
	var openMenu = $("ul.show").length;
	if (openMenu == 0) { // abre o primeiro menu se nenhum estiver aberto
		$($("ul.collapse").get(0)).addClass("show");
	}
	// Slider de preço
	if ($('.price-filter a.prices').length > 0) {
		var prices = $('.price-filter a.prices').attr('data-rel').split("-");
		var minPrice = parseInt(prices[0]);
		var maxPrice = parseInt(prices[1]);
		var minPriceActual = parseInt(prices[2]);
		var maxPriceActual = parseInt(prices[3]);
	}
	if ($('#slider-range').length > 0) {

		var url = location.href.split("/?");
		if (url[1] != undefined) {
		}

		var paramPrice = getURLParameter('price');

		$("#slider-range").slider({
			range: true,
			min: minPrice,
			max: maxPrice,
			values: [minPriceActual, maxPriceActual],
			slide: function (event, ui) {
				$("#amount").val("R$ " + ui.values[0] + " - R$ " + ui.values[1]);
			},
			change: function (event, ui) {
				if (url[1] != undefined) {
					/*
					 * queryParameters -> handles the query string parameters
					 * queryString -> the query string without the fist '?' character
					 * re -> the regular expression
					 * m -> holds the string matching the regular expression
					 */
					var queryParameters = {}, queryString = location.search.substring(1),
						re = /([^&=]+)=([^&]*)/g, m;

					// Creates a map with the query string parameters
					while (m = re.exec(queryString)) {
						queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
					}

					// Add new parameters or update existing ones
					queryParameters['price'] = ui.values[0] + "-" + ui.values[1];

					/*
					 * Replace the query portion of the URL.
					 * jQuery.param() -> create a serialized representation of an array or
					 *     object, suitable for use in a URL query string or Ajax request.
					 */
					location.href = "?" + $.param(queryParameters); // Causes page to reload
				} else {
					location.href = location.href + "?price=" + ui.values[0] + "-" + ui.values[1];
				}
			}
		});
		$("#amount").val("R$ " + $("#slider-range").slider("values", 0) +
			" - R$ " + $("#slider-range").slider("values", 1));
	}
})
